import { monthCloseOutAlertConstants } from '../../actions/constant';

const {
  UPLOAD_MONTH_END_ALERT_SIGN_REQUEST,
  UPLOAD_MONTH_END_ALERT_SIGN_SUCCESS,
  UPLOAD_MONTH_END_ALERT_SIGN_FAILURE,
  UPLOAD_MONTH_END_ALERT_SIGN_LOADING,
  UPLOAD_MONTH_END_ALERT_SIGN_RESET,
} = monthCloseOutAlertConstants;
const intitialstate: object = {
  response: null,
  getStatus: false,
  loading: false,
};

export const uploadSignatureFileReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case UPLOAD_MONTH_END_ALERT_SIGN_SUCCESS: {
      return {
        ...state,
        getStatus: true,
        response: action.payload,
        loading: false,
      };
    }

    case UPLOAD_MONTH_END_ALERT_SIGN_FAILURE:
      return {
        ...state,
        getStatus: false,
        response: action.payload,
        loading: false,
      };

    case UPLOAD_MONTH_END_ALERT_SIGN_LOADING:
      return {
        ...state,
        loading: true,
      };

    case UPLOAD_MONTH_END_ALERT_SIGN_RESET:
      return intitialstate;

    default:
      return state;
  }
};
